module.exports = __webpack_public_path__ + "static/media/window-minimize.0dbac90b.svg";